import { DropdownButton, DropdownButtonItem } from '@salecycle/ui-component-library';
import { State as LifeCycleState } from 'entities/lifecycle';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useOffsiteCampaignEditorDispatch,
  useOffsiteCampaignEditorState,
} from '../../context/UseOffsiteCampaignEditorContext';

export const CampaignActionsButton: FC = () => {
  const { t } = useTranslation('campaigns');
  const dispatch = useOffsiteCampaignEditorDispatch();
  const { campaign } = useOffsiteCampaignEditorState();
  const onChange = (state: LifeCycleState) => {
    dispatch({
      type: 'SET_CAMPAIGN_STATE',
      payload: { state },
    });
  };
  const onStart = () => onChange('ACTIVE');
  const onPause = () => onChange('INACTIVE');
  const onDelete = () => onChange('DELETED');
  const onTest = () => onChange('TESTING');
  const onMigration = () => onChange('MIGRATION');

  return (
    <DropdownButton variation="clean" icon="ellipsis-v" menuPlacement="right">
      {campaign.state === 'ACTIVE' ? (
        <DropdownButtonItem onClick={onPause}>{t('campaigns:campaignActions.pause')}</DropdownButtonItem>
      ) : null}
      {campaign.state === 'INACTIVE' ? (
        <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
      ) : null}
      {campaign.state !== 'DELETED' ? (
        <DropdownButtonItem onClick={onDelete}>{t('campaigns:campaignActions.archive')}</DropdownButtonItem>
      ) : (
        <DropdownButtonItem onClick={onPause}>{t('campaigns:campaignActions.restore')}</DropdownButtonItem>
      )}
      {campaign.state === 'INACTIVE' || campaign.state === 'ACTIVE' ? (
        <>
          <DropdownButtonItem onClick={onTest}>{t('campaigns:campaignActions.test')}</DropdownButtonItem>
        </>
      ) : null}
      {campaign.state === 'MIGRATION' ? (
        <>
          <DropdownButtonItem onClick={onTest}>{t('campaigns:campaignActions.test')}</DropdownButtonItem>
          <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
        </>
      ) : null}
      {campaign.state === 'TESTING' ? (
        <>
          <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
        </>
      ) : null}
      {campaign.state === 'INACTIVE' || campaign.state === 'ACTIVE' || campaign.state === 'TESTING' ? (
        <DropdownButtonItem onClick={onMigration}>{t('campaigns:campaignActions.migrate')}</DropdownButtonItem>
      ) : null}
    </DropdownButton>
  );
};
